import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";
import { getTeamThreadTitle, isTeamGroup } from "../team-thread";

export const TeamThreadCard = ({
  thread,
  currentUserId,
  currentPersonalInboxId,
  selected,
  handleSelect,
  togglePersonalMeta,
  setPersonalMeta,
  isMetaPending,
}) => {
  const isUnread = thread.meta_values?.includes("unread");
  const readPending = isMetaPending(thread.id, "unread");
  const priorityPending = isMetaPending(thread.id, "priority");
  const archivePending = isMetaPending(thread.id, "archived");
  const isArchived = thread.meta_values?.includes("archived");
  const title = getTeamThreadTitle(
    thread,
    currentUserId,
    currentPersonalInboxId,
  );
  const isGroup = isTeamGroup(thread);
  const participantCount = Math.max(
    thread.participants?.length || 0,
    thread.participant_ids?.length || 0,
  );
  const iconSrc = isGroup
    ? "/images/private-message-team.svg"
    : "/images/private-message-individual.svg";

  return (
    <div
      className={classnames("chat-guest-contact-wrapper team-thread-card", {
        "active-chat-guest-contact": selected,
        "thread-unread": isUnread,
      })}
    >
      <div className="message-text-group" onClick={() => handleSelect(thread.id)}>
        <span
          className="message-text-group-icon team-thread-avatar"
          uk-tooltip={isGroup ? "Private team group" : "Private team message"}
        >
          <Image src={iconSrc} />
          <span
            className="team-thread-private-badge"
            aria-label="Private conversation"
          >
            <FeatherIcon name="lock" />
          </span>
        </span>
        <div>
          <div className="semi-bold-font">{title}</div>
          <div className="secondary">
            {isGroup
              ? `${participantCount} Participants`
              : ""}
            {isArchived ? `${isGroup ? " · " : ""}Archived` : ""}
          </div>
          <div
            className={
              isUnread ? "chat-guest-unread-message" : "chat-guest-message"
            }
          >
            {thread.last_msg?.length > 60
              ? `${thread.last_msg.slice(0, 60)}…`
              : thread.last_msg}
          </div>
          <div className="chat-guest-contact-date">
            {moment
              .utc(thread.last_message_on)
              .local()
              .format("MMM DD, YYYY hh:mm a")}
          </div>
        </div>
      </div>
      <div className="messages-btn-group">
        <button
          type="button"
          className="uk-button hms-simple-icon-btn inbox-read-state-indicator"
          onClick={() => setPersonalMeta(thread.id, "unread", !isUnread)}
          disabled={readPending}
          uk-tooltip={isUnread ? "Mark as Read" : "Mark as Unread"}
        >
          {readPending ? (
            <span uk-spinner="ratio: 0.6" />
          ) : (
            <FeatherIcon name={isUnread ? "eye-off" : "eye"} />
          )}
        </button>
        <button
          type="button"
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-priority":
              thread.meta_values?.includes("priority"),
          })}
          onClick={() => togglePersonalMeta(thread.id, "priority")}
          disabled={priorityPending}
          uk-tooltip="Prioritize"
        >
          {priorityPending ? (
            <span uk-spinner="ratio: 0.6" />
          ) : (
            <FeatherIcon name="flag" />
          )}
        </button>
        <button
          type="button"
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-archived": isArchived,
          })}
          onClick={() => togglePersonalMeta(thread.id, "archived")}
          disabled={archivePending}
          uk-tooltip={isArchived ? "Unarchive" : "Archive"}
        >
          {archivePending ? (
            <span uk-spinner="ratio: 0.6" />
          ) : (
            <FeatherIcon name="archive" />
          )}
        </button>
      </div>
    </div>
  );
};
